/* global Swiper */
// **********************************************************
// Open Gallery Model
// **********************************************************

const openModal = (event) => {
  const parentEle = event.target.closest('.image-gallery');
  const galleryModal = parentEle.querySelector('.gallery-modal');
  galleryModal.classList.add('is-open-modal');
}

attachEvent('.image-gallery__image', 'click', (ev) => openModal(ev));
attachEvent('.image-gallery__button', 'click', (ev) => openModal(ev));


